function doLightBox(){
  if(customElements.get('lightbox-i')) return null;

  class Lightbox extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('[data-trigger]');
      this.content = this.querySelector('[data-content]');
      this.addClassToLightbox = this.getAttribute('data-class');
      this.isOpen = false;

      this.bindEvents();
    }

    bindEvents() {
      if (this.trigger) {
        this.trigger.addEventListener('click', this.open.bind(this));
      }
    }

    open() {
      if (this.isOpen) return;

      // Get the template element
      const lightboxTemplate = document.getElementById('Lightbox-i');

      // Show lightbox and set content
      if(!lightboxTemplate || !this.content) return;
      if(this.addClassToLightbox){
        lightboxTemplate.classList.add(this.addClassToLightbox);
      }
      const lightboxContent = lightboxTemplate.querySelector('.lightbox-content');
      if (lightboxContent) {
        lightboxContent.innerHTML = this.content.innerHTML;
      }

      // Add close button event
      const closeButton = lightboxTemplate.querySelector('.lightbox-close');
      if (closeButton) {
        closeButton.addEventListener('click', this.close.bind(this));
      }

      // Click outside to close
      lightboxTemplate.addEventListener('click', (e) => {
        if (e.target === lightboxTemplate) {
          this.close();
        }
      });

      // Prepare for animation
      lightboxTemplate.style.display = 'flex';
      lightboxTemplate.style.opacity = '0';

      // Trigger reflow to ensure animation happens
      void lightboxTemplate.offsetWidth;

      // Start fade-in animation
      lightboxTemplate.style.opacity = '1';
      document.body.classList.add('lightbox-open');

      this.isOpen = true;
    }

    close() {
      if (!this.isOpen) return;

      const lightboxTemplate = document.getElementById('Lightbox-i');

      if (lightboxTemplate) {
        // Start fade-out animation
        lightboxTemplate.style.opacity = '0';
        document.body.classList.remove('lightbox-open');

        // Hide after animation completes
        setTimeout(() => {
          lightboxTemplate.style.display = 'none';

          // Clear content after closing
          const lightboxContent = lightboxTemplate.querySelector('.lightbox-content');
          if (lightboxContent) {
            lightboxContent.innerHTML = '';
          }
        }, 300);
      }

      this.isOpen = false;
    }
  }

  customElements.define('lightbox-i', Lightbox);
}

doLightBox();
